/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import isMatch from 'lodash.ismatch';

export function isObjectMatch(obj: Record<string, unknown>, source: Record<string, unknown>) {
  return isMatch(obj, source);
}
